import React from 'react';
import CertificationsPage from '../../components/Certifications/CertificationsPage';

const Certifications = () => {
  return <CertificationsPage />;
};

export default Certifications;
